module.exports = __webpack_public_path__ + "img/icon_no_job.06c95425.svg";